import { Pipe, PipeTransform } from '@angular/core';
import { DataContextService } from '../../../services/datacontext.service';
import * as moment from 'moment';
import 'moment-timezone';

@Pipe({
  name: 'mPipe',
})
export class DatexPipe implements PipeTransform {
  constructor(private dataContextService: DataContextService) {
  }
  transform(value: any, format: string = '', tz: string = '', locale = ''): string {
    let momentDate;

    if (tz) {
      momentDate = moment.tz(value, tz);
    } else {
      momentDate = moment(value);
    }

    // If moment didn't understand the value, return it unformatted.
    if (!momentDate.isValid()) {
      return value;
    }

    // Otherwise, return the date formatted as requested.
    if (!locale) {
      locale = this.dataContextService.defaultLanguage;
    }
    return momentDate.locale(locale).format(format);
  }
}
